import { observer } from 'mobx-react';
import { T } from '../Translations';

function AnnouncementsHeader() {
  return (
    <h2 tabIndex={0}>
      <T kind="Announcements" />
    </h2>
  );
}

export default observer(AnnouncementsHeader);
